<template lang="pug">
.container-fluid
  Loader(v-if="loader")
  vm-row(vm-w="12")
    vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
      .top-menu()
        .top-menu-item(v-for="(item, index) in topMenu" :key="index" @click="changeMenuOpt(item.num)" :class="selectedMenu === item.num ? 'selected-menu' : ''")
          vm-icon(:icon="item.icon" size="1.5rem" :color="selectedMenu === item.num ? '#D06325' : '' ")
          span(:class="selectedMenu === item.num ? 'text-menu-selected' : '' ") {{ $t(item.text) }}
  transition(name="menu-fade" mode="out-in")
    ProjectDasboard(v-if="selectedMenu === 1")
    ManufacturingDashboard(v-if="selectedMenu === 2")
    CustomerPurchaseOrderDashboard(v-if="selectedMenu === 3")
    SupplierPurchaseDashboard(v-if="selectedMenu === 4")
    CustomerInvoicesDashboard(v-if="selectedMenu === 5")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')
const Loader = () => import('@/components/aditionals/Loader.vue')
const ProjectDasboard = () => import('@/components/project-dashboard/ProjectDasboard.vue')
const ManufacturingDashboard = () => import('@/components/project-dashboard/ManufacturingDashboard.vue')
const CustomerPurchaseOrderDashboard = () => import('@/components/project-dashboard/CustomerPurchaseOrderDashboard.vue')
const SupplierPurchaseDashboard = () => import('@/components/project-dashboard/SupplierPurchaseDashboard.vue')
const CustomerInvoicesDashboard = () => import('@/components/project-dashboard/CustomerInvoicesDashboard.vue')

export default {
  name: 'ProjectsDetails',
  components: {
    Loader,
    ManufacturingDashboard,
    ProjectDasboard,
    CustomerPurchaseOrderDashboard,
    SupplierPurchaseDashboard,
    CustomerInvoicesDashboard
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    selectedMenu: 1,
    topMenu: [
      {
        num: 1,
        icon: 'grid-outline',
        text: 'strings.dashboard'
      },
      {
        num: 2,
        icon: 'layers-outline',
        text: 'strings.manufacturing'
      },
      {
        num: 3,
        icon: 'file-outline',
        text: 'strings.customer_oc'
      },
      {
        num: 4,
        icon: 'trending-down-outline',
        text: 'strings.supplier_oc'
      },
      {
        num: 5,
        icon: 'trending-up-outline',
        text: 'strings.invoices'
      }
    ]
  }),

  computed: {
    ...mapGetters(['project', 'loader'])
  },
  async created () {
    this.setLoaderVisible(true)
    if (this.$route.params.id) {
      await this.loadProject({ id: this.$route.params.id }).then(() => {
        this.loadPurcharseOrders({ id: this.$route.params.id })
        this.setLoaderVisible(false)
      })
    }
  },
  methods: {
    ...mapActions([
      'loadProject',
      'loadPurcharseOrders',
      'setLoaderVisible'
    ]),
    changeMenuOpt (payload) {
      this.selectedMenu = payload
    }
  }
}
</script>
<style lang="scss">

.top-menu {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  margin-bottom: 2rem;

  .top-menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
}
.text-menu-selected {
  color: rgba($color: var(--primary), $alpha: 1.0);
}
.selected-menu {
  -webkit-box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
  -moz-box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
  box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
}
.menu-fade-enter-active, .menu-fade-leave-active {
  transition: opacity .3s ease;
}
.menu-fade-enter, .menu-fade-leave-to
/* .menu-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.con-vm-viewer {
  z-index: 200000 !important;
}
</style>
